import script from "./DiamondNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiamondNav.vue?vue&type=script&setup=true&lang=ts"

import "./DiamondNav.vue?vue&type=style&index=0&id=46a94fce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a94fce"]])

export default __exports__